import { Component, effect, forwardRef, Host, input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EnabledModulesEnum } from '../../../../../common/enums/EnabledModulesEnum';

type VoucherAtpInputType = 'parametersLabel' | 'parameters' | 'secureParameters' | 'enabledModules' | 'contextName';

@Component({
  selector: 'app-voucher-atp-inputs',
  templateUrl: './voucher-atp-inputs.component.html',
  styleUrls: ['./voucher-atp-inputs.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => VoucherAtpInputsComponent),
      multi: true
    }
  ]
})
export class VoucherAtpInputsComponent implements OnInit, ControlValueAccessor {
  label = input<string>('');
  type = input<VoucherAtpInputType>('parametersLabel');
  formControlName = input<string>('');
  canModify = input.required<boolean>();

  formControl!: FormControl;
  protected readonly Object = Object;
  protected readonly EnabledModulesEnum = EnabledModulesEnum;

  constructor(
    @Optional()
    @Host()
    @SkipSelf()
    private controlContainer: ControlContainer
  ) {
    effect(() => {
      if (this.formControl) {
        if (this.canModify()) {
          this.formControl.enable();
        } else {
          this.formControl.disable();
        }
      }
    });
  }

  ngOnInit() {
    if (this.controlContainer) {
      const formControl = this.controlContainer.control.get(this.formControlName()) as FormControl;
      if (formControl) {
        this.formControl = formControl;
      } else {
        console.warn(`${this.constructor.name} => Missing FormControl directive from host element of the component`);
      }
    } else {
      console.warn(`${this.constructor.name} => Can't find parent FormGroup directive`);
    }
  }

  writeValue(value: string) {}

  registerOnChange(fn: any) {}

  registerOnTouched(fn: any) {}

  setDisabledState(isDisabled: boolean): void {}
}
